import React from 'react'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme =>({
    slide: {
        position: "relative",
        flex: "0 0 100%",
    },
}));

export default function Slide({children, className = "", ...props}) {
    const classes = useStyles();
    
    const displayProps = {
        className: `${classes.slide} ${className}`,
        ...props,
    }

    return (
        <div {...displayProps}>
            {children}
        </div>
    )
}